import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function RoleStep({ profile, saveField }) {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="ob-name">Your name</Label>
        <Input
          id="ob-name" placeholder="Alex Chen" className="mt-1.5"
          value={profile.name || ""}
          onChange={(e) => saveField({ name: e.target.value })}
          data-testid="onboarding-name"
        />
      </div>
      <div>
        <Label htmlFor="ob-role">Current role</Label>
        <Input
          id="ob-role" placeholder="Senior Product Manager" className="mt-1.5"
          value={profile.current_role || ""}
          onChange={(e) => saveField({ current_role: e.target.value })}
          data-testid="onboarding-role"
        />
      </div>
    </div>
  );
}
